import { authenticatedPost } from '../../api/request';

export default async function createDoctorAppointment(data) {
  try {
    const response = await authenticatedPost(`/appointment-user/create`, null, data);
    return response;
  } catch (error) {
    throw error;
  }
}

